<template>

    <div class="container-fluid">
        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row px-3 mb-3">
                      <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                    </div>
                </div>
                <div v-if="agentsChargDto.evaluationObjectIds.length>0" class="mt-3">
                    Мулклар: <strong>{{agentsChargDto.evaluationObjectIds}}</strong>
                </div>
                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-2 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("accounting.account.province")}}</label>
                                <v-select v-model="filter.province" label="name"
                                          :options="provinces"
                                          :filterable="false"
                                          :disabled="regionalLeaderProvince!=null"
                                          @search="onProvinceGetRegionsChange"
                                          @change="onProvinceGetRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                            <div class="col-xl-2 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("accounting.account.city")}} ва
                                    {{$t("accounting.account.district")}}</label>
                                <v-select v-model="filter.region" label="name"
                                          :options="regions"
                                          :filterable="false"
                                          @search="searchByFilter"
                                          @change="searchByFilter">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                            <div class="col-xl-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("report.field.agents")}}</label>
                                <v-select v-model="filter.user" label="text"
                                          :options="users"
                                          :filterable="false"
                                          @search="onUsersSearch"
                                          @search:focus="onUsersFocus">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.user && filter.user.name">
                                        <div v-html="filter.user.name"
                                             @click="$eventBus.$emit('search:focus')"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-xl-1 col-lg-2 col-md-2 col-sm-6 mb-2">
                                <label style="align-self: center">ID</label>
                                <numeric-input v-model="filter.objectId" :precision="2" required></numeric-input>
                            </div>

                            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("report.field.paymentStatus")}}</label>
                                <select class="form-control" v-model="filter.paymentStatus">
                                    <option value="ALL">{{$t('report.field.paymentStatusAll')}}</option>
                                    <option value="PAID">{{$t('report.field.paymentStatusPaid')}}</option>
                                    <option value="UNPAID">{{$t('report.field.paymentStatusUnPaid')}}</option>
                                </select>
                            </div>

                            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("report.field.paymentStatusSalary")}}</label>
                                <select class="form-control" v-model="filter.paymentStatusSalary">
                                    <option value="ALL">{{$t('report.field.paymentStatusAll')}}</option>
                                    <option value="PAID">{{$t('report.field.paymentStatusPaid')}}</option>
                                    <option value="UNPAID">{{$t('report.field.paymentStatusUnPaid')}}</option>
                                </select>
                            </div>

                            <div class="col-sm-1">
                                <label style="align-self: center">{{$t("main.search")}}</label>
                                <button class="all-btn form-control" @click="initList"
                                        style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                                    <i class="fa fa-search"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                <div v-if="agentsChargDto.evaluationObjectIds.length>0" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("accounting.account.paymentDocument")}}
                                    {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="agentsChargDto.number"
                                       placeholder=" Раками"/>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("report.field.createdDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="agentsChargDto.date"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <label>{{$t("accounting.account.paymentDocument")}}
                                    {{$t("accounting.account.totalAmount")}}</label>
                                <input type="text" class="form-control" v-model="agentsChargDto.price"
                                       placeholder=" Суммаси"/>
                            </div>

                            <div class="col-lg-2 col-sm-6 align-self-end mb-2">
                                <button style="float:left" type="button" class="all-btn m-0"
                                        data-dismiss="modal"
                                        v-on:click="saveAgentsCharg()"> Сақлаш
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body scroll-card-body table-responsive">
                        <table class="customers">
                            <thead>
                            <tr>
                                <th colspan="9"></th>
                                <th colspan="2">
                                    {{$t("accounting.account.invoice")}}
                                </th>
                                <th colspan="3">
                                    {{$t("accounting.account.property")}}
                                </th>
                                <th colspan="4">
                                    {{$t("report.field.payment")}}
                                </th>
                                <!--<th colspan="1">-->
                                <!--{{$t("report.field.paymentDate")}}-->
                                <!--</th>-->
                                <th colspan="3">
                                    {{$t("report.field.paymentDate")}}
                                </th>
                                <th colspan="2">
                                    {{$t("report.field.salary")}}
                                </th>
                            </tr>
                            <tr>

                                <th>{{$t("main.number")}}</th>
                                <th>{{$t("report.field.objectNumber")}}</th>
                                <th>{{$t("report.field.fullName")}}</th>
                                <th>{{$t("report.field.province")}}</th>
                                <th>{{$t("report.field.district")}}</th>
                                <th>{{$t("report.field.organization")}}</th>
                                <th>{{$t("report.field.ownerClient")}}</th>
                                <th>{{$t("report.field.name")}}</th>
                                <th>{{$t("report.field.evaluationPurpose")}}</th>
                                <th>{{$t("accounting.account.number")}}</th>
                                <th>{{$t("accounting.account.date")}}</th>
                                <th>{{$t("accounting.account.propertyType")}}</th>
                                <th>{{$t("report.field.quantity")}}</th>
                                <th>{{$t("accounting.account.totalAmountQQS")}}</th>
                                <th>{{$t("report.field.paid")}}</th>
                                <th>{{$t("report.field.unpaid")}}</th>
                                <th>{{$t("accounting.account.additionalCalculatedMoney")}}</th>
                                <th>{{$t("accounting.account.societyFunds")}}</th>
                                <th>{{$t("accounting.account.date")}}</th>
                                <th>{{$t("accounting.account.number")}}</th>
                                <th>{{$t("accounting.account.totalAmount")}}</th>
                                <th>{{$t("report.field.unpaid")}}</th>
                                <th>{{$t("report.field.paid")}}</th>

                            </tr>

                            </thead>
                            <tbody>
                            <template v-if="results">
                                <tr v-for=" (result, index) in results.data" :key="result.id">
                                    <td><input type="checkbox" :disabled="result.paidAgentStatus"
                                               :value="result.evaluationObjectId"
                                               v-model="agentsChargDto.evaluationObjectIds"> {{index+1}}
                                    </td>
                                    <td> <a :href="getOpenLink(result)" target="_blank">{{result.evaluationObjectId}}</a></td>
                                    <td>{{result.createUserName}} <br/>
                                        <b>{{result.createdUserRoleName}}</b>
                                    </td>
                                    <td>{{result.provinceName}}</td>
                                    <td>{{result.regionName}}</td>
                                    <td :title="result.clientFullInfo">{{result.clientShortInfo}}</td>
                                    <td :title="result.debtorName">{{result.shortDebtorName}}</td>
                                    <td :title="result.evaluationObjectFullInfo">{{result.evaluationObjectShortInfo}}
                                    </td>
                                    <td>{{result.evlGoalType}}</td>
                                    <td>{{result.contractNumber}}</td>
                                    <td>{{result.contractDate}}</td>
                                    <td>{{result.evlObjectType}}</td>
                                    <td>{{result.objectQty}}</td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">
                                        {{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">{{result.paid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">{{result.unpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">{{result.companyMoney | currency('', 2, { thousandsSeparator: ' ' })}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">
                                        {{result.additionaCalculatedAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">
                                        {{result.agentSaloryPaymentDate}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">
                                        {{result.agentSaloryPaymentNumber}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">
                                        {{result.agentSaloryPaymentSum | currency('', 2, { thousandsSeparator: ' ' })}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">{{result.agentSalory | currency('', 2, { thousandsSeparator: ' ' })}}
                                    </td>
                                    <td :class="[result.paidAgentStatus ?'tdpaid':'tdunpaid']">
                                        {{result.agentSaloryPaid | currency('', 2, { thousandsSeparator: ' ' })}}
                                    </td>

                                </tr>
                            </template>
                            </tbody>
                            <tfoot>
                            <tr v-if="loadingTotal">
                                <loading2 style="" v-if="loadingTotal"></loading2>
                            </tr>
                            <tr v-if="!loadingTotal">
                                <td colspan="1" class="font-weight-bold">Жами</td>
                                <td colspan="12" class="font-weight-bold">{{results? results.total: 0}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.contractAmountTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.debtorTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.creditorTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.societyFundsTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.mainCalculatedMoneyTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="3" class="font-weight-bold"></td>
                                <td class="font-weight-bold">{{tableTotalValue.unpaidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="font-weight-bold">{{tableTotalValue.paidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-12 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate} from '@/shared/utils';
    import Loading2 from '@/views/Loading2';
    // export const
    export default {
        name: "Agents",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            Loading2,
        },
        data: function () {
            return {
                loading: false,
                loadingTotal: true,
                checkboxVal: false,
                show: false,
                filter: initFilterModel(),
                results: null,
                users: [],
                agentsChargDto: {
                    number: null,
                    date: null,
                    price: null,
                    evaluationObjectIds: [],
                },
                tableTotalValue: [],
                regionalLeaderProvince: null,
                province: {},
                region: {},
                provinces: [],
                regions: [],
            }
        },


        methods: {
            initList() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });

                const regionalLeader = vm.$store.state.profile.regionalLeader;
                if (regionalLeader){
                    const regionalLeaderProvince = regionalLeader.userProvinces[0];
                    vm.filter.province = regionalLeaderProvince;
                    vm.regionalLeaderProvince = regionalLeaderProvince;
                }

                this.loading = true;
                this.filter.agentReport = true;
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.$http.post('/report/list/agents', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
                this.initTableTotal();
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.users = [];
                this.filter.search = searchTxt;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.users = [];
                this.filter.search = '';
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            saveAgentsCharg: function () {
                this.loading = true;
                this.$http.post('/agent/charg/save/', this.agentsChargDto).then(res => {
                    this.loading = false;
                    console.log(res.data.data);
                    this.agentsChargDto.evaluationObjectIds = [];
                    this.initList();
                }, err => {
                    console.log(err);
                });
            },
            initTableTotal() {
                const vm = this;
                this.loadingTotal = true;
                this.$http.post('/report/list/agents/total', this.filter).then(res => {
                    this.loadingTotal = false;
                    console.log(res.data);
                    const initData = res.data;
                    vm.tableTotalValue = initData.dataTotal;
                }, err => {
                    console.log(err);
                });
            },
            getOpenLink(result) {
                if (result.evlObjectTypeDto.code === 'Auto') {
                    return process.env.VUE_APP_WEB_URL + 'automulti/view?autoId=' + result.evaluationObjectId;
                } else if (result.evlObjectTypeDto.code === 'Fitment') {
                    return process.env.VUE_APP_WEB_URL + 'fitment/view/' + result.evaluationObjectId;
                }
                return "";
            },
            onProvinceGetRegionsChange() {
                let regions = [];
                if (this.filter.province && this.filter.province.id && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
                // this.filter.region = null;
                this.searchByFilter();
            },
            searchByFilter() {
                this.filter.page.page = 1;
                // this.initList();
                // this.initTableTotal();
            },
        },

        created() {
            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filter.startDate = new Date(currYear, currMonth, 1);
            this.filter.endDate = new Date(currYear, currMonth, d.getDate());

            this.initList();
        },
    }
</script>
<style>
    .scroll-card-body {
        overflow-x: scroll;
        overflow-y: visible;
    }

    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
        white-space: nowrap;
    }

    .tdpaid {
        background-color: #9de0f6;
        color: red;
    }

    .tdunpaid {
        background-color: transparent;
    }
</style>

